import React from 'react';
import TabsMenu from '../TabsMenu';
import { Switch, Route } from 'react-router-dom';
import Page404 from '../Page404';
import UserSettings from './components/UserSettings';

const Settings = (props) => {
	const tabs = ['Benutzer verwalten']; //Declaring tabs to be displayed.
	const defaultPath = props.match.path.match(/.*?(?=\/:)/)[0]; //Declaring default path.

	return (
		<Switch>
			{tabs.map((tab, index) => {
				return (
					<Route
						exact
						key={index}
						path={`${defaultPath}/${index}`}
						component={() => (
							<TabsMenu title={'einstellungen'} subtitle={tab} tabs={tabs} defaultPath={defaultPath} align={'align-self-baseline'}>
								{tab === 'Benutzer verwalten' && <UserSettings />}
							</TabsMenu>
						)}
					/>
				);
			})}
			<Route component={Page404} />
		</Switch>
	);
};

export default Settings;
